import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  exports: [],
})
export class ODataModule {
  static forRoot(): ModuleWithProviders<ODataModule> {
    return {
      ngModule: ODataModule,
    };
  }
}
